import matchAll from "string.prototype.matchall";
import React from "react";
import ReactDOM from "react-dom";
import configureStore from "store/configureStore";
import { updateRoutePrefix } from "store/actions/localeActions";
import { syncTranslationWithStore } from "react-redux-i18n";
import DragManager from "store/DragManager";
import SaveManager from "store/SaveManager";
import TextManager from "store/TextManager";
import ReduxSubscriber from "store/ReduxSubscriber";
import { ElementDataManager } from "store/ElementDataManager";
import App from "./App";

import "normalize.css";
import "editor/styles.scss";

matchAll.shim();
updateRoutePrefix(process.env.TRANSLATIONS_URL);

const store = configureStore();
syncTranslationWithStore(store);

// Save store as a window object so we can access it from
// iframe
window.store = store;

window.ReduxSubscriber = new ReduxSubscriber();
window.DragManager = new DragManager(store);
window.SaveManager = new SaveManager(store);
window.ElementDataManager = new ElementDataManager(store);
window.TextManager = new TextManager(store);

window.ACCOUNTS_URL = process.env.ACCOUNTS_URL;
window.BASE_API = process.env.BASE_API;
window.APP_CODE = process.env.APP_CODE;
window.ENV = process.env.NODE_ENV;
window.isDev = window.ENV === "development";
window.isProd = window.ENV === "production";

function renderApplication() {
  ReactDOM.render(<App store={store} />, document.getElementById("root"));
}

try {
  const { token } = JSON.parse(localStorage.getItem("prosite"));
  window.USER_TOKEN = token;
  renderApplication();
} catch (e) {
  const { protocol, host, pathname, search, href } = window.location;
  if (search !== "") {
    const uri = new URL(href);
    if (uri.searchParams.get("token")) {
      window.USER_TOKEN = uri.searchParams.get("token");
      renderApplication();
    }
  }

  if (!window.USER_TOKEN) {
    console.log(
      "[PROSITE] window.USER_TOKEN not defined, redirecting to login page"
    );
    const redirPage = `${protocol}//${host}`;
    const baseUrl = `${window.ACCOUNTS_URL}/auth/accounts/login?srv=prosite&path=`;
    window.location.href = `${baseUrl}${pathname.slice(1)}&host=${redirPage}`;
  }
}
